import { useHistory } from "react-router-dom";
import React, { useEffect, useState, useContext } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Grid, Container, Typography } from "@material-ui/core";
import { useStyles } from "../../assets/styles/CustomStyles";
import axios from "../../utils/axios";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import { BotonGris } from "../../assets/styles/StyledButtons";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
  notificacionError,
  alertWarningError,
} from "../../components/Notificaciones";
import TypographyBold from "../../components/TypographyBold";
import BackdropCustom from "../../components/BackdropCustom";
import Paper from "@material-ui/core/Paper";
import MaterialTable from "material-table";
import Localizacion from "../../components/MaterialTables/Localization";
import TableIcons from "../../components/MaterialTables/TableIcons";
import Chip from "@material-ui/core/Chip";
import Close from "@material-ui/icons/Close";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import CardHeader from '@material-ui/core/CardHeader';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DateIcon from '@material-ui/icons/DateRange';
import IconButton from '@material-ui/core/IconButton';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AccesoDenegado from "../../components/AccesoDenegado";
import UserContext from "../../utils/user/UserContext";

const tableColumns = [
  {
    field: "descripcion", title: "N°", width: "5%", render: rowData => <Typography variant="caption" display="block" > {rowData.tableData.id + 1}</Typography>
  },
  { field: "descripcion", title: "Descripción" },
  { field: "cantidad", title: "Cantidad", width: "10%" },
  { field: "impuesto", title: "Impuesto", width: "10%" },
  { field: "precio_unitario", title: "Precio Unitario", align: "right", width: "10%" },
  { field: "sub_total", title: "Sub Total", align: "right", width: "10%" },
];


const DetalleFacturacion = () => {
  const history = useHistory();

  const dataProps = history.location.state;

  const classes = useStyles();
  const userContext = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [factura, setFactura] = useState({});
  const [pdf, setPdf] = useState(true);
  const localization = Localizacion;
  const tableIcons = TableIcons;



  useEffect(() => {

    getFactura();
  }, []);

  const getFactura = async () => {
    console.log(dataProps)
    try {
      setIsLoading(true);
      const response = await axios.get("facturacion/funConsultaFactura.php", {
        params: {
          id: dataProps.id,
        },
      });
      let status = response.status
      if (status === 200) {
        setIsLoading(false);
        setFactura(response.data[0]);

        if (response.data[0]?.nro_factura  !== "") {
          setPdf(false)
        } else {
          setPdf(true)
        }
      }

    } catch (error) {
      if (error.response) {
        alertWarningError(error.response);
      }
    } finally {
      setIsLoading(false);
    }
  };


  const handlePDF = async () => {
    let tokenCookies = sessionStorage.getItem("jwt-jr");
    let url = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}extensiones/tcpdf/pdf/vFacturaInforme.php?nroFactura=${factura?.id}&p=${JSON.parse(tokenCookies).token}`
    var win = window.open(url, '_blank');
    win.focus();

  }
  return (
    <>
      <BackdropCustom open={isLoading} />
      {Number(userContext.state.accesos.facturacion) === 1 ?
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          style={{ marginBottom: 10 }}

        >
          <Card className={classes.root}>
            <CardHeader
              action={<>
                <Chip label={factura?.fecha} variant="default" icon={<DateIcon />} />

                <IconButton disabled={pdf} aria-label="print" onClick={handlePDF}>
                  <PictureAsPdf />
                </IconButton>
                <IconButton aria-label="exit" onClick={(e) => {
                  history.goBack();
                }}>
                  <Close />
                </IconButton>

              </>

              }
              title={<Typography variant="body1" >
                INFORMACION DE LA FACTURACION <Chip label={factura?.nro_factura} variant="default" size="small" icon={<AssignmentIcon />} />
              </Typography>}
            />
            <CardContent >
              <Paper >
                <Box p={1} mb={2} >
                  <Box ml={1} >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                      <Grid container direction="row" >
                        <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                          <TypographyBold variant="body2" display="block" color="textSecondary">
                            DESTINATARIO DEL CLIENTE
                          </TypographyBold>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={5}>
                          <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                              <List dense>
                                <ListItem>
                                  <ListItemIcon className={classes.buttonFiltro}>
                                    <TypographyBold variant="subtitle2" color="inherit" >
                                      Denominación:
                                    </TypographyBold>
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={factura?.nombre}
                                  />
                                </ListItem>
                                <ListItem>
                                  <ListItemIcon className={classes.buttonFiltro}>
                                    <TypographyBold variant="subtitle2" color="inherit" >
                                      RUC:
                                    </TypographyBold>
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={factura?.ruc}
                                  />
                                </ListItem>
                                <ListItem>
                                  <ListItemIcon className={classes.buttonFiltro}>
                                    <TypographyBold variant="subtitle2" color="inherit" >
                                      Domicilio:
                                    </TypographyBold>
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={factura?.direccion}
                                  />
                                </ListItem>

                              </List>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={5}>
                          <Grid container >
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <List dense>
                                <ListItem>
                                  <ListItemIcon className={classes.buttonFiltro}>
                                    <TypographyBold variant="subtitle2" color="inherit" >
                                      Nota de Remisión N°:
                                    </TypographyBold>
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={factura?.nro_factura_remision}
                                  />
                                </ListItem>
                                <ListItem>
                                  <ListItemIcon className={classes.buttonFiltro}>
                                    <TypographyBold variant="subtitle2" color="inherit" >
                                      N° Remisión impresión:
                                    </TypographyBold>
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={factura?.nro_remision_impresion}
                                  />
                                </ListItem>

                                <ListItem>
                                  <ListItemIcon className={classes.buttonFiltro}>
                                    <TypographyBold variant="subtitle2" color="inherit" >
                                      Condición de venta:
                                    </TypographyBold>
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={factura?.tipo_de_pago}
                                  />
                                </ListItem>
                              </List>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Paper>


              <MaterialTable

                columns={tableColumns}
                data={factura?.items}
                localization={localization}
                icons={tableIcons}
                options={{
                  // showTitle: false,
                  toolbar: false,
                  filtering: false,
                  search: false,
                  headerStyle: { position: "sticky", top: 0 },
                  maxBodyHeight: "55vh",
                  paging: false,
                  draggable: false,
                  rowStyle: {
                    fontSize: "small",
                  },
                }}

              />
              <Box ml={1} >
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                  <Grid container direction="row" className={classes.alignDerecha} >

                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                      <List dense>
                        <ListItem>
                          <ListItemIcon >
                            <TypographyBold variant="subtitle2" color="inherit" >
                            IVA (5%):
                            </TypographyBold>
                          </ListItemIcon>
                          <ListItemText
                            className={classes.buttonFiltro}
                            primary={factura?.iva_5}
                          />
                        </ListItem>
                      </List>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                      <List dense>
                        <ListItem>
                          <ListItemIcon >
                            <TypographyBold variant="subtitle2" color="inherit" >
                            (10%):
                            </TypographyBold>
                          </ListItemIcon>
                          <ListItemText
                            className={classes.buttonFiltro}
                            primary={factura?.iva_10}
                          />
                        </ListItem>
                      </List>
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <List dense>
                        <ListItem>
                          <ListItemIcon >
                            <TypographyBold variant="subtitle2" color="inherit" >
                              TOTAL:
                            </TypographyBold>
                          </ListItemIcon>
                          <ListItemText
                            className={classes.buttonFiltro}
                            primary={factura?.total}
                          />
                        </ListItem>

                      </List>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        : <AccesoDenegado />}
    </>
  );
};

export default DetalleFacturacion;
